'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColorTypes = undefined;

var _type = require('./type');

var PresetColorTypes = exports.PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');